import Vue from 'vue';
import * as MUTATIONS from '@/store/constants/mutations.js';

export const mutations = {
    [MUTATIONS.SET_ACTIVE_WORKSPACE](state, { workspace_uuid }) {
        if (!state.active_workspaces[workspace_uuid]) {
            Vue.set(state.active_workspaces, workspace_uuid, { workspace_uuid });
        }
        Object.assign(state.active_workspaces[workspace_uuid], { workspace_uuid });
    },
    [MUTATIONS.CLEAR_ACTIVE_WORKSPACE](state, workspace_uuid) {
        Vue.delete(state.active_workspaces, workspace_uuid);
    },
    [MUTATIONS.SET_ACTIVE_QUICK_SEARCH](state, { quick_search_id }) {
        if (!state.active_quick_searches[quick_search_id]) {
            Vue.set(state.active_quick_searches, quick_search_id, { quick_search_id });
        }
        Object.assign(state.active_quick_searches[quick_search_id], { quick_search_id });
    },
    [MUTATIONS.CLEAR_ACTIVE_QUICK_SEARCH](state, quick_search_id) {
        Vue.delete(state.active_quick_searches, quick_search_id);
    },
};
